export default [
    {
        title : 'Subestaciones',
        icon : 'subestacion',
        items : [
            { name : 'Subestaciones', link : '/subestaciones' },
            { name : 'Elementos Comunes Subestaciones', link : '/elementos-comunes-ssee' },
            { name : 'Patios', link : '/patios-subestaciones' },
            { name : 'Elementos Comunes Patios', link : '/elementos-comunes-patios' },
            { name : 'Barras', link : '/barras' },
            { name : 'Paños', link : '/panos' },
            { name : 'Elementos Comunes Paños', link : '/elementos-comunes-panos' },
            { name : 'Equipos', subitemId: 'menuEquiposSSEE', 
            subitems : [
                    { name : 'Transformadores 2D', link : '/transformadores-2d' },
                    { name : 'Transformadores 3D', link : '/transformadores-3d' },
                    { name : 'Interruptores', link : '/interruptores' },
                    { name : 'Desconectadores', link : '/desconectadores' },
                    { name : 'Transformadores de Corrientes', link : '/transformadores-corriente' },
                    { name : 'Transformadores Potenciales', link : '/transformadores-potencial' },
                    { name : 'Transformadores SS/AA', link : '/transformadores-ssaa' },
                    { name : 'Pararrayos', link : '/pararrayos' },
                    { name : 'Trampas de Ondas', link : '/trampas-ondas' },
                    { name : 'Aisladores', link : '/aisladores' },
                    { name : 'Medidores', link : '/medidores' },
                    { name : 'Condensadores Síncronos', link : '/condensadores-sincronos' },
                    { name : 'Compensadores Activos', link : '/compensadores-activos' },
                    { name : 'Condensadores Series', link : '/condensadores-series' },
                    { name : 'Compensadores Estáticos Reactivos', link : '/compensadores-estaticos-reactivos' },
                    { name : 'Condensadores de Acoplamiento', link : '/condensadores-acoplamiento' },
                    { name : 'Bancos Condensadores', link : '/bancos-condensadores' },
                    { name : 'Reactores', link : '/reactores' },
                    { name : 'Dispositivos Reconexión', link : '/dispositivos-reconexiones' },
                    { name : 'Celdas', link : '/celdas' },
                    { name : 'Transformadores ZigZag (P.A.T)', link : '/transformadores-zigzag' },
                ] 
            },
            { name : 'Paneles Antirruido', link : '/paneles-antirruido' },
            // { name : 'Bien Equipos Vehículos', link : '/bienes-equipos-vehiculos' },
            { name : 'Servidumbres', link : '/servidumbres' },
        ]
    },
    {
        title : 'Control y Protecciones',
        icon : 'subestacion',
        items : [
            { name : 'SS.GG., Casetas y Salas de ER', link : '/casas-servicios-generales-y-casetas' },
            { name : 'Equipos SS.GG. y Casetas', subitemId: 'menuEquiposSSGG', 
                subitems : [
                    { name : 'Bancos de Baterias', link : '/bancos-baterias' },
                    { name : 'Generadores de Energía', link : '/generadores-energia' },
                    { name : 'Tableros', link : '/tableros' },
                    { name : 'Elementos Comunes SSGG y Casetas', link : '/elementos-comunes-ssgg-casetas' },
                ]
            },
            { name : 'Armarios', link : '/armarios' },
            { name : 'Telecomunicaciones', subitemId: 'menuTelecos', 
                subitems : [
                    { name : 'Multiplexadores', link : '/multiplexadores' },
                    { name : 'Equipos Principales de Comunicación', link : '/equipos-principales-comunicacion' },
                    // { name : 'Equipos MMOO ', link : '/equipos-mmoo' },
                    // { name : 'Equipos OPLAT ', link : '/equipos-oplat' },
                    { name : 'Otros Elementos de Telecomunicaciones', link : '/otros-elementos-telecomunicaciones' },
                ]
            },
            { name : 'Sistemas de Protección', subitemId: 'menuSistemasProtec', 
                subitems : [
                    { name : 'Relés de Protecciones', link : '/reles-proteccion' },
                    { name : 'Otros Elementos Sistemas de Protección ', link : '/otros-elementos-sistemas-proteccion' },
                ]
            },
            { name : 'Sistemas de Control', subitemId: 'menuSistemasControl', 
                subitems : [
                    { name : 'Controladores de Bahía', link : '/controladores-bahia' },
                    { name : 'Medidores', link : '/medidores' },
                    { name : 'Otros Elementos Sistemas de Control', link : '/otros-elementos-sistemas-control' },
                ]
            },
            { name : 'Servicios Auxiliares', subitemId: 'menuSSAA', 
                subitems : [
                    // { name : 'Servicios Auxiliares CA y CC', link : '/servicios-auxiliares-ca-y-cc' },
                    { name : 'Elementos Comunes Armarios', link : '/elementos-comunes-armarios' },
                ]
            },
            { name : 'Respaldo Baterias', subitemId: 'menuRespaldoBaterias', 
                subitems : [
                    { name : 'Sistemas de Respaldo de Energía', link : '/sistemas-respaldo-energia' },
                ]
            },
            { name : 'Estaciones Repetidoras', link : '/estaciones-repetidoras' }
        ]
    },
    {
        title : 'Líneas de Transmisión',
        icon : 'linea',
        items : [
            { name : 'Líneas', link : '/lineas' },
            { name : 'Circuitos', link : '/circuitos' },
            { name : 'Tramos', link : '/tramos' },
            { name : 'Activos Tramos', subitemId: 'menuActivosTramos', 
            subitems : [
                    { name : 'Vanos', link : '/vanos' },
                    { name : 'Equipos Vanos', subitemId: 'menuEquiposVanos', 
                    subitems : [
                        { name : 'Accesorios Vanos', link : '/accesorios-vanos' },
                        // { name : 'Amortiguadores', link : '/amortiguadores' },
                        // { name : 'Conductores', link : '/conductores' },
                        // { name : 'Monitores de Línea', link : '/monitores-lineas' },
                        // { name : 'Espaciadores', link : '/espaciadores' },
                        // { name : 'Boyas de Señalización', link : '/boyas-senalizacion' },
                        // { name : 'Cables de Guardia', link : '/cables-guardia' },
                    ] },
                    { name : 'Túneles', link : '/tuneles' },
                ]
            },
            { name : 'Servidumbres', link : '/servidumbres' },
        ]
    },
]
